import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { VerifyEmailService } from '../../../services/auth/verify-email.service';

@Component({
  selector: 'app-signed-up',
  templateUrl: './signed-up.component.html',
  styleUrls: ['./signed-up.component.scss'],
})
export class SignedUpComponent {
  state: 'Sending' | 'CanSend';
  email: string;

  constructor(
    route: ActivatedRoute,
    private service: VerifyEmailService,
  ) {
    route.queryParamMap.subscribe(map => {
      if (map.has('email')) {
        this.email = map.get('email');
        this.state = 'CanSend';
      }
    });
  }

  resend() {
    this.state = 'Sending';
    this.service.resend(this.email);
    setTimeout(() => (this.state = 'CanSend'), 5000);
  }
}
